import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Thumbs } from 'swiper/modules'
import Meta from '../components/common/Meta'
import 'swiper/css'
import 'swiper/css/thumbs'
import 'swiper/css/effect-fade'
import designServices from '../assets/images/projects/birembo/Birembo3.jpg'
import realEstate from '../assets/images/projects/kanombe/Kanombe5.jpg'
import constructionServices from '../assets/images/projects/birembo/Birembo8.jpg'
import landSurveying from '../assets/images/projects/kanombe/Kanombe7.jpg'
import '../css/main.css'

const slides = [
  {
    image: designServices,
    title: 'Design Services',
    description:
      'Creative architectural designs that shape the future. We offer tailored design solutions combining innovation, sustainability, and functionality to meet each client’s unique vision and needs.'
  },
  {
    image: constructionServices,
    title: 'Construction Services',
    description:
      'Building durable, high-quality structures from the ground up. Our expert construction team ensures precision, efficiency, and safety throughout the project lifecycle, delivering lasting results.'
  },
  {
    image: landSurveying,
    title: 'Land Surveying Services',
    description:
      'Precision surveying for accurate project planning and development. We use advanced technology to provide reliable data that supports successful land use, boundary identification, and engineering design.'
  },
  {
    image: realEstate,
    title: 'Real Estate Services',
    description:
      'Connecting people with their dream properties and investments. Whether buying, selling, or leasing, our real estate experts offer guidance, transparency, and market insight for smart decision-making.'
  }
]

function HeroSlider() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Main Swiper */}
      <Swiper
        modules={[Autoplay, Thumbs]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        thumbs={{ swiper: thumbsSwiper }}
        className="min-h-screen"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="w-screen min-h-screen bg-cover bg-center bg-no-repeat relative"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
            <div className="absolute bottom-1/4 left-8 md:left-16 z-10 max-w-md">
              <div className="bg-black/40 backdrop-blur-sm p-6 md:p-8 rounded-xl">
                <h1 className="text-xl md:text-2xl font-bold mb-3 bg-gradient-to-r from-white to-teal-200 bg-clip-text text-transparent">
                  {slide.title}
                </h1>

                <p className="text-sm md:text-base leading-relaxed mb-5 text-blue-100">
                  {slide.description}
                </p>

                <button className="inline-flex text-sm items-center text-white bg-primary-dark px-5 py-3 rounded-md font-semibold shadow-lg hover:bg-primary-light transition">
                  More Projects
                  <i className="fa fa-angle-double-right ml-2" />
                </button>
              </div>
            </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Thumbnails Swiper */}
      <div className="absolute bottom-6 left-0 right-0 z-20 px-4">
        <Swiper
          onSwiper={setThumbsSwiper}
          spaceBetween={10}
          slidesPerView={4}
          watchSlidesProgress
          className="max-w-4xl mx-auto"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={`thumb-${index}`}>
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-24 object-cover cursor-pointer rounded-md border-2 border-transparent hover:border-white transition"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default HeroSlider
